<template>
  <el-dialog
    :title="isResend ? 'Resend Invite' : 'Invite new member'"
    :visible.sync="setShow"
    width="28%"
    @close="cancel"
  >
    <el-form :model="form" label-position="top" ref="form" @submit.prevent>
      <el-row type="flex">
        <el-col :span="24">
          <el-form-item
            label="Email"
            prop="email"
            :rules="validateEmail('Email')"
          >
            <el-input type="email" v-model="form.email" :disabled="isResend" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="24">
          <member-role-input :roles.sync="form.roles" />
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button plain size="medium" @click="cancel">Cancel</el-button>
      <el-button
        type="primary"
        size="medium"
        :loading="sending"
        @click="invite"
        >{{ isResend ? "Resend" : "Send" }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import MemberRoleInput from "@/components/Organisation/Members/MemberRoleInput.vue";

export default {
  name: "OrganisationMemberInvite",
  components: { MemberRoleInput },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    member: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      isResend: false,
      sending: false,
      form: {
        email: "",
        roles: []
      }
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.setForm();
      }
    }
  },
  created() {
    this.setForm();
  },
  methods: {
    cancel() {
      this.form = {
        email: "",
        roles: []
      };
      this.setShow = false;
    },
    setForm() {
      if (this.member.account_user) {
        this.isResend = true;
        this.form.email = this.member.account_user.email;
        this.form.roles =
          this.member.user_roles &&
          this.member.user_roles.map(role => role.role_id);
      } else {
        this.form = {
          email: "",
          roles: []
        };
      }
    },
    invite() {
      this.$refs.form.validate(async valid => {
        if (!valid || this.isVerified) {
          return false;
        }

        this.sending = true;
        this.$http
          .post("accounts/users/invite", {
            body: this.form,
            method: "POST"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
              this.sending = false;
            } else {
              this.notification(
                "Invitation",
                "Invite sent successfully",
                "success"
              );
              this.sending = false;

              if (!this.isResend) {
                this.$emit("updated");
              }
              this.cancel();
            }
          })
          .catch(() => {
            this.notification("Error", "An unknown error occurred", "danger");
            this.sending = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
